import { render, staticRenderFns } from "./SuppliersPage.vue?vue&type=template&id=0f1edb10"
import script from "./SuppliersPage.vue?vue&type=script&lang=js"
export * from "./SuppliersPage.vue?vue&type=script&lang=js"
import style0 from "./SuppliersPage.vue?vue&type=style&index=0&id=0f1edb10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports